import { render, staticRenderFns } from "./loading.vue?vue&type=template&id=857136e2&scoped=true"
var script = {}
import style0 from "./loading.vue?vue&type=style&index=0&id=857136e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "857136e2",
  null
  
)

export default component.exports